module.exports = "<ng-template [ngIf]=\"hasSource\">\n\t<figure>\n\t\t<img (error)=\"imageErrorHandler($event)\" src=\"{{source}}\" alt=\"\">\n\t</figure>\n</ng-template>\n<ng-template [ngIf]=\"!hasSource\">\n\t<div *ngIf=iconName class=\"c-avatar__icon\">\n\t\t<i class=\"icon__n icon__n--{{iconName}}\"></i>\n\t</div>\n\t<div *ngIf=letters class=\"c-avatar__letters\">\n\t\t<span>{{letters}}</span>\n\t</div>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/avatar/avatar.component.html
// module id = ./src/app/modules/common-module/components/avatar/avatar.component.html
// module chunks = 9